// extracted by mini-css-extract-plugin
export default {"slidedown":"_20ex0lEyMLPRuwgBjUz0WK","slidedown--entering":"_1Y7AsRcvKrptvQc1g96HxF","slidedown--entered":"_2iuXb_2fQBp4Z4amrTjSrJ","slidedown--exiting":"K9k2tVfD9j2bt1oD7xmK0"};